
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","data-name":"Lasso Icon","width":"12","height":"12","viewBox":"0 0 12 12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 41","d":"M.912 12a.336.398 0 01-.334-.342.977 1.156 0 01-.004-.231c.002-.04.004-.082.004-.151a.314.372 0 01.34-.393 59.969 59.969 0 011.705 0h.01A1.14 1.35 0 003.81 9.671a1.724 2.04 0 00-.007-.422 1.393 1.648 0 01-1.11-1.544C.985 6.888-.022 5.542 0 4.106.017 3 .638 1.966 1.747 1.196A8.319 9.842 0 015.895.001h.171a8.41 9.95 0 014.22 1.323c1.123.82 1.73 1.892 1.714 3.017-.017 1.106-.638 2.14-1.747 2.911a8.318 9.841 0 01-4.147 1.193h-.171a8.64 8.64 0 01-.543-.028 1.41 1.668 0 01-.572.666 4.151 4.911 0 01.026.531 1.948 2.305 0 01-.664 1.687A2.278 2.695 0 012.647 12h-.025a88.94 88.94 0 00-1.016-.008c-.36 0-.54.004-.648.006h-.04zm3.212-4.994a.552.653 0 10.572.653.563.666 0 00-.572-.653zm0-.979A1.43 1.692 0 015.5 7.21c.151.012.306.02.459.023h.158a7.5 8.873 0 003.363-.849c.898-.547 1.4-1.284 1.412-2.072.012-.805-.485-1.572-1.4-2.16a7.621 9.017 0 00-3.44-.951h-.158a7.497 8.87 0 00-3.363.847c-.899.548-1.4 1.284-1.412 2.073a1.644 1.945 0 00.517 1.385 4.105 4.857 0 001.417 1.073 1.456 1.722 0 011.071-.55z"}})])
          )
        }
      }
    